module.exports = __webpack_public_path__ + "assets/AEqualSegments1Detailed.e371b2279a1a4d2febc1ad105ca95582.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/AEqualSegments1Detailed.png
// module id = 452
// module chunks = 0